import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {TableHeadCell, TableHeadRow} from '@components/common/base/table'
import {cn} from '@containers/html-utils'
import {ShowMore} from '../common/show-more'
import {canSeeEmails} from '../dashboard-utils'
import {UserFields} from '../user-fields'
import {UserItem} from './user-item'
import {useCompanyUsersStore} from './users-store'

export const TABLE_FIRST_COL_WIDTH = 250

export const UsersTable = observer(() => {
  const [state, store] = useCompanyUsersStore()

  return (
    <>
      <TableHeader />

      {state.filterQuery ? (
        <FilteredList />
      ) : (
        <>
          {state.notDistributedUsers.length > 0 && (
            <>
              <NotDistributedUsers />
              <UserList
                list={state.notDistributedUsers}
                className="mt-16 border-solid border-0 border-b-1 border-grey-l60 mb-8"
              />
            </>
          )}
          <UserList list={state.distributedUsers.slice(0, state.maxShow)} />
          <ShowMore
            list={state.distributedUsers}
            maxShow={state.maxShow}
            handler={e => store.showMore(e)}
          />
        </>
      )}
    </>
  )
})

const Cell = tw(TableHeadCell)`
  cursor-default
  flex-1
  flex-col
  !px-16
  !items-start
`

const TableHeader = () => {
  return (
    <TableHeadRow className="mt-16 -mx-16">
      <Cell minWidth={TABLE_FIRST_COL_WIDTH}>
        {Lang.msg.companyDashboard.employee}
      </Cell>
      {canSeeEmails() && <Cell>{Lang.msg.email}</Cell>}
      <Cell>{Lang.msg.permission.position}</Cell>
      <Cell>{Lang.msg.permission.department}</Cell>
    </TableHeadRow>
  )
}

const NotDistributedUsers = () => {
  return (
    <div className="mt-16 flex text-14 text-error font-semibold leading-4">
      {Lang.msg.companyDashboard.unassignedEmployees}
    </div>
  )
}

const FilteredList = observer(() => {
  const [state] = useCompanyUsersStore()
  return state.filtered.length > 0 ? (
    <UserList list={state.filtered} highlight />
  ) : (
    <div className="text-placeholder">{Lang.msg.usersTable.noUserFound}</div>
  )
})

const UserList = ({
  list,
  highlight = false,
  className
}: {
  list: UserFields[]
  highlight?: boolean
  className?: string
}) => {
  return (
    <div className={cn('-mx-16', className)}>
      {list.map(user => (
        <UserItem key={user.id} user={user} highlight={highlight} />
      ))}
    </div>
  )
}
